<template>
    <b-modal
        id="rubric-cell-description"
        v-model="modal"
        :title="$t('common.description')"
        hide-footer
        size="sm"
        modal-class="apprentice-default-modal rubric-cell-description-modal">
        <div class="description">
            {{ description }}
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-cell-description-component',
    data() {
        return {
            description: '',
            modal: false,
        };
    },
    methods: {
        show(cellData) {
            this.description = cellData;
            this.modal = true;
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    font-size: $default-font-size;
    color: $text-color;
}
</style>
